"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./bootstrap");
const sentry_1 = require("./services/sentry");
const Map_1 = __importDefault(require("~/app/Map"));
const locale_1 = require("~/services/locale");
const PageFormatter_1 = __importDefault(require("~/services/PageFormatter"));
const Permalink_1 = __importDefault(require("~/services/Permalink"));
const settings_1 = require("~/settings");
const utils_1 = require("~/utils/utils");
require("./sass/map.scss");
window.addEventListener("DOMContentLoaded", function () {
    return __awaiter(this, void 0, void 0, function* () {
        (0, settings_1.loadSettings)();
        (0, sentry_1.initSentry)(settings_1.settings.sentry);
        // Singletons
        const pageFormatter = new PageFormatter_1.default();
        const permalink = new Permalink_1.default();
        yield (0, locale_1.loadLocale)(settings_1.settings.locale);
        JGN.map = new Map_1.default("myMap", permalink, pageFormatter);
        (0, utils_1.checkBrowser)();
    });
});
